import { ExternalLink, Languages, Menu, Moon, Sun, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { GITHUB_URL } from '../siteContent';

export default function Navbar({ content, theme, onToggleTheme, onToggleLanguage }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const nextTheme = theme === 'dark' ? 'light' : 'dark';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} aria-label="Main navigation">
      <a className="brand" href="#top" aria-label="NEXT Engine home">
        <img className="brand-icon" src="/icon.svg" alt="NEXT Engine icon" />
        <span className="brand-text">NEXT Engine</span>
      </a>

      <div className={`nav-links ${mobileOpen ? 'open' : ''}`}>
        {content.links.map((link) => (
          <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)}>
            {link.label}
          </a>
        ))}
      </div>

      <div className="nav-actions">
        <button
          className="nav-icon-button"
          type="button"
          onClick={onToggleLanguage}
          aria-label={content.languageLabel}
          title={content.languageLabel}
        >
          <Languages size={17} />
          <span>{content.language}</span>
        </button>
        <button
          className="nav-icon-button icon-only"
          type="button"
          onClick={onToggleTheme}
          aria-label={`Switch to ${nextTheme} theme`}
          title={`Switch to ${nextTheme} theme`}
        >
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <a className="nav-github" href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
          <ExternalLink size={15} />
          <span>{content.github}</span>
        </a>
        <button
          className="mobile-toggle"
          type="button"
          onClick={() => setMobileOpen((open) => !open)}
          aria-label="Toggle menu"
          title="Toggle menu"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
}
